<template>
  <!--
    	作者：zct
    	时间：2021-10-08
    	描述：单位-编辑单位
    -->
  <div class="product-add">
    <!--form表单-->
    <el-form size="small" ref="form" :model="form" label-width="80px">
      <!--编辑单位-->
      <div class="common-form">编辑单位</div>
      <el-form-item label="单位名称" prop="unit_name" :rules="[{required: true,message: ' '}]">
        <el-input v-model="form.unit_name" placeholder="请输入单位名称" class="max-w460"></el-input>
      </el-form-item>
      <!-- <el-form-item label="单位logo">
        <el-row>
          <el-button icon="el-icon-picture-outline" @click="openUpload">选择图片</el-button>
          <div v-if="file_path!=''" class="img">
            <img :src="file_path" width="100" />
          </div>
        </el-row>
      </el-form-item> -->

      <!--提交-->
      <div class="common-button-wrapper">
        <el-button size="small" type="info" @click="cancelFunc">取消</el-button>
        <el-button size="small" type="primary" @click="onSubmit" :loading="loading">提交</el-button>
      </div>
    </el-form>
    <!--上传图片组件-->
    <Upload v-if="isupload" :isupload="isupload" :type="type" @returnImgs="returnImgsFunc">上传图片</Upload>

  </div>
</template>

<script>

  import unitApi from '@/api/unit.js';
  import Upload from '@/components/file/Upload';

  import { formatModel } from '@/utils/base.js'
  export default {
    components: {
      Upload,
    },
    data() {
      return {
        /*form表单数据*/
        form: {
          unit_id:null,
          unit_name: '',

        },

        /*是否上传图片*/
        isupload: false,
        loading: false,
        file_path: '',
        open_user:false,

      };
    },
    created() {

      this.form.unit_id =this.$route.query.unit_id;

      this.getData();
    },

    methods: {
      /*修改*/
      onSubmit() {
        let self = this;
        let form = self.form;
        self.$refs.form.validate((valid) => {
          if (valid) {
            self.loading = true;
            unitApi.editUnit(form, true)
              .then(data => {
                self.loading = false;
                self.$message({
                  message: '恭喜你，单位修改成功',
                  type: 'success'
                });
                self.$router.push('/unit/unit/index');
              }).catch(error => {
                self.loading = false;
              });
          }
        });
      },

      /*获取参数*/
      getData() {
        let self = this;
        unitApi.unitDetail({
            unit_id: self.form.unit_id
          }, true)
          .then(res => {
            self.form = formatModel(self.form, res.data.model);

          })
          .catch(error => {

          });

      },

      /*上传*/
      openUpload(e) {
        this.type = e;
        this.isupload = true;
      },

      /*获取图片*/
      returnImgsFunc(e) {
        if (e != null) {
          this.file_path = e[0].file_path;
          this.form.logo_image_id = e[0].file_id;
        }
        this.isupload = false;
      },



      /*取消*/
      cancelFunc() {
        this.$router.back(-1);
      },


    }

  };
</script>

<style lang="scss" scoped>
  .basic-setting-content {}

  .product-add {
    padding-bottom: 50px;
  }

  .img {
    margin-top: 10px;
  }
</style>



// WEBPACK FOOTER //
// src/views/unit/unit/edit.vue